/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Error_Hint_Chip_TitleInputs */



/**
* | output |
* | --- |
* | "The open app reported an error. It is attached to your next message, exactly as shown:" |
*
* @param {Canvas_Error_Hint_Chip_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_error_hint_chip_title = /** @type {((inputs?: Canvas_Error_Hint_Chip_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Error_Hint_Chip_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die geöffnete App hat einen Fehler gemeldet. Er wird genau so an deine nächste Nachricht angehängt:")
	return /** @type {LocalizedString} */ ("The open app reported an error. It is attached to your next message, exactly as shown:")
});